module.exports = __webpack_public_path__ + "img/caja-del-santa.2537a3a7.svg";